// import ShimmerLoading from "./modules/ShimmerLoading.js";
import { useState, useEffect, lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Splash from "./ui/Splash.js";

const CreateLiteUrl = lazy(() => import('./modules/CreateLiteUrl.js'));
const DynamicPage = lazy(() => import('./modules/DynamicPage.js'));
const NotFoundPage = lazy(() => import('./modules/NotFoundPage.js'));
const Analytics = lazy(() => import('./modules/Analytics.js'));
const MyUrls = lazy(() => import('./modules/MyUrls.js'));

function App() {
  if (localStorage.getItem("LiteUrlTokenUser") == null) {
    localStorage.setItem(
      "LiteUrlTokenUser",
      "dummy_user" + Math.random(11111, 99999)
    );
  }
  const [registeredUser, setRegisteredUser] = useState(
    localStorage.getItem("LiteUrlTokenUser")
  );

  const [userLocationData, setUserLocationData] = useState("Restricted Location");
  const [loadInteraction, setLoadInteraction] = useState(false);

  useEffect(() => {
    const loadScriptOnUserAction = function () {
      // Loaded on demand so Firebase stays out of the main bundle (short-link redirects never need it)
      import("./api/LiteURLApi.js")
        .then(({ default: LiteURLApi }) => LiteURLApi.getClientLocation())
        .then((data) => {
          setUserLocationData(data);
        })
        .catch((error) => {
          setUserLocationData("Restricted Location");
          console.error("Error updating data:", error);
        });

      setLoadInteraction(true);
      window.removeEventListener("click", loadScriptOnUserAction);
      window.removeEventListener("touchstart", loadScriptOnUserAction);
      window.removeEventListener("mouseover", loadScriptOnUserAction);
    };

    window.addEventListener("click", loadScriptOnUserAction);
    window.addEventListener("touchstart", loadScriptOnUserAction);
    window.addEventListener("mouseover", loadScriptOnUserAction);
  }, []);


  return (
    <Router>
      <a href="#main" className="skip-link">
        Skip to content
      </a>
      <Suspense fallback={<Splash />}>
        <Routes>
          <Route path="/404/*" element={<NotFoundPage />} />
          <Route path="/my-urls/*" element={<NotFoundPage />} />
          <Route path="/:key" element={<DynamicPage userLocationData={userLocationData} />} />
          <Route
            path="/my-urls/"
            element={
              <MyUrls
                setRegisteredUser={setRegisteredUser}
                registeredUser={registeredUser}
                userLocationData={userLocationData}
                loadInteraction={loadInteraction}
              />
            }
          />
          <Route
            path="/analytics/:key"
            element={<Analytics setRegisteredUser={setRegisteredUser} registeredUser={registeredUser} userLocationData={userLocationData} />}
          />
          <Route
            path="/"
            element={
              <CreateLiteUrl
                userLocationData={userLocationData}
                setRegisteredUser={setRegisteredUser}
                registeredUser={registeredUser}
                loadInteraction={loadInteraction}
              />
            }
          />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
